export const BETA = 4.166;
export const DEFAULT_MU = 25.0;
export const DEFAULT_SIGMA = 8.333;

// Score margin weighting constants
export const MAX_SCORE = 10;
export const MARGIN_SCALE_FACTOR = 0.7; // 70% scale for normal margins

// Sigma floor to cap high-volume player advantage (~30 games)
export const SIGMA_FLOOR = 1.83;
